export default function (props: any) {
    return (
        <svg width="52" height="52" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <circle fill="#000" opacity=".16" cx="26" cy="26" r="26" />
                <g opacity=".7">
                    <path d="M11 11h30v30H11z" />
                    <path
                        d="m28.299 26-7.865 7.937A1.453 1.453 0 0 0 20 35c0 .417.145.77.434 1.063.289.291.64.437 1.052.437.413 0 .764-.146 1.053-.438L31.52 27c.661-.667.64-1.354-.061-2.063l-8.919-9a1.427 1.427 0 0 0-1.053-.437c-.412 0-.763.146-1.052.437A1.453 1.453 0 0 0 20 17c0 .417.145.77.434 1.063L28.299 26z"
                        fill="#FFF"
                    />
                </g>
            </g>
        </svg>
    );
}
